import React from 'react';
import {AnimatePresence, motion} from "framer-motion";
import {useTranslation} from "react-i18next";

// Modale d'invitation au quiz du jour, affichée après le parcours mi-temps, par-dessus le classement.
// Refus non bloquant : un bandeau de rejeu reste disponible sur le classement.
export const QuizUpsellModal = ({isOpen, onAccept, onDecline}) => {
    const {t} = useTranslation();

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-4"
                    initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}
                >
                    <div className="absolute inset-0 bg-slate-900/75 backdrop-blur-sm"/>

                    <motion.div
                        initial={{y: 60, opacity: 0, scale: 0.96}}
                        animate={{y: 0, opacity: 1, scale: 1}}
                        exit={{y: 40, opacity: 0}}
                        transition={{type: 'spring', damping: 22, stiffness: 260}}
                        className="relative z-10 w-full max-w-sm bg-brand-dark rounded-3xl p-7 overflow-hidden shadow-2xl text-center"
                    >
                        <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-64 rounded-full bg-action-green/25 blur-[70px] pointer-events-none"/>

                        <div className="relative z-10">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1 mb-4 rounded-full bg-action-green/15 border border-action-green/30">
                                <span className="text-sm leading-none">⚡</span>
                                <span className="text-[10px] font-black text-action-green uppercase tracking-widest">
                                    {t('quiz_upsell.badge', 'Quiz du jour')}
                                </span>
                            </div>

                            <h3 className="text-2xl font-black text-white uppercase tracking-tight leading-none mb-2">
                                {t('quiz_upsell.title', 'Booste ton score !')}
                            </h3>
                            <p className="text-sm text-gray-400 font-medium leading-relaxed mb-6">
                                {t('quiz_upsell.subtitle', 'Réponds au quiz du jour et gagne des points bonus au classement.')}
                            </p>

                            <button
                                onClick={onAccept}
                                className="w-full py-4 mb-3 bg-action-green text-white font-bold rounded-xl text-base shadow-lg hover:brightness-110 active:scale-98 transition-transform"
                            >
                                {t('quiz_upsell.accept', 'Je joue le quiz')} ⚡
                            </button>
                            <button
                                onClick={onDecline}
                                className="w-full py-3 text-gray-400 hover:text-white font-bold text-sm uppercase tracking-widest transition-colors"
                            >
                                {t('quiz_upsell.decline', 'Plus tard')}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default QuizUpsellModal;
